<!-- <p>
  drzava-update works!
</p> -->
<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="NAME.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNaziv"
              formControlName="Name"
              #focusElement
              [MaxLength]="200"
              [ngClass]="{'is-invalid': submitted && fc.Name.invalid}"
              [Label]="'NAME.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Name.invalid">
                <span *ngFor="let validation of errorMessages.Name">
                  <span class="error-message" *ngIf="fc.Name.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>